module.exports = __webpack_public_path__ + "static/media/40_B.4eb7468a.png";